import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export interface StarIconProps extends SvgIconProps {}

export const StarIcon = ({ style, ...iconProps }: StarIconProps) => {
  return (
    <SvgIcon
      style={{ fontSize: '1em', ...style }}
      {...iconProps}
      viewBox="0 0 48 44"
    >
      <path
        d="M23.7714 35.3325L38.4571 43.9634L34.5714 27.6982L47.5451 16.7542L30.4594 15.3439L23.7714 0.00222778L17.0857 15.3417L0 16.7542L12.9737 27.6982L9.088 43.9634L23.7714 35.3325Z"
        fill="#A7A7A7"
      />
    </SvgIcon>
  );
};

export default StarIcon;
